query getCompetitionsBetween(
    $startDate: Datetime
    $endDate: Datetime
    $sportId: UUID
) {
    competitions: allCompetitionsHavingEventsBetween(
    startdate: $startDate
    enddate: $endDate
    sportid: $sportId
    filter: {
        limbo: { equalTo: false }
        competitionCoverageAvailablesByCompetitionId: {
        some: { available: { equalTo: true } }
        }
    }
    ) {
        nodes {
            competitionId
            competitionName
            region {
                regionId
                regionName
            }
            competitionFavoritesByCompetitionId {
            nodes {
            competition {
                competitionName
                competitionId
                }
            }
        }
        }
    }
}
